export enum RangeFormats {
    YEAR = "YYYY",
    MONTH = "MM-YYYY"
}

export enum RangeTypes {
    YEAR = "year",
    MONTH = "month"
}

export enum ChartTypes {
    EMPTY = "",
    PIE = "pie_chart",
    BAR = "bar_chart",
    STACKED = "stacked_chart",
    LAYERED = "bars_layered_chart",
    EXCEL = "excel"
}

export enum ChartGroupKeys {
    YEAR = "Год",
    MONTH = "Месяц-год"
}
